import React from 'react';
import PropTypes from 'prop-types';
import { Toggle } from '@storable/canaveral-components';
import styles from './styles.scss';

const propTypes = {
  toggleShowDrafts: PropTypes.func.isRequired,
  showDrafts: PropTypes.bool.isRequired,
};

const defaultProps = {};

const DraftToggle = ({ toggleShowDrafts, showDrafts }) => (
  <div className={`${styles.container} col-6`}>
    <Toggle onClick={toggleShowDrafts} checked={showDrafts} />
    <div className={styles.label}>
      <div className={styles.heading}>
        Show Draft Pages
      </div>
      <div>
        {"Draft pages won't appear on your website until published."}
      </div>
    </div>
  </div>
);

DraftToggle.propTypes = propTypes;
DraftToggle.defaultProps = defaultProps;

export default DraftToggle;
